import { WSAlert } from "@wingspanhq/fe-component-library";
import { Batch } from "@wingspanhq/wingspan-api-sdk";
import pluralize from "pluralize";

import { useDownloadSkippedRows } from "../../hooks/useDownloadSkippedRows";
import { useSkippedRowsCount } from "../../hooks/useSkippedRowsCount";

type Props = {
  batch: Batch;
  sheetSlug: string;
  /** Singular noun for what the batch imports, e.g. "Payable". */
  entityLabel: string;
};

/**
 * The same skipped rows as `ImportBatchUploadRejectionsAlert`, worded for a
 * batch that has already been imported: nothing can be added to it any more.
 */
export const ImportBatchUploadUnuploadedRowsAlert: React.FC<Props> = props => {
  const skippedRowsCount = useSkippedRowsCount(props.batch, props.sheetSlug);
  const downloadSkippedRows = useDownloadSkippedRows(props);

  if (!skippedRowsCount) {
    return null;
  }

  return (
    <WSAlert
      theme="warning"
      icon="alert"
      name="uploadRejections"
      title="Some rows could not be uploaded"
      action={{
        text: "Download skipped rows",
        onClick: downloadSkippedRows
      }}
    >
      {pluralize("row", skippedRowsCount, true)} could not be uploaded and were
      not imported. You can correct these rows and upload them separately.
    </WSAlert>
  );
};
